<template>
  <div>
    <!-- Seção 1: Locutor Publicitário -->
    <section class="section" data-aos="fade-up">
      <div class="container">
        <div class="media">
          <img
            src="/assets/work-estudio.jpg"
            alt="Locutor Publicitário"
            loading="lazy"
            decoding="async"
            width="400"
            height="500"
          />
        </div>
        <div class="text">
          <h2>Locutor Publicitário</h2>
          <p>
            Faço gravações de áudio em português e Inglês de home studio próprio para
            clientes no Brasil, Argentina, Espanha, além de TV, internet e instituições
            governamentais e corporativas.
          </p>
        </div>
      </div>
    </section>

    <!-- Seção 2: Mestre de Cerimônias -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <img
            src="/assets/work_copa-01.jpg"
            alt="Mestre de Cerimônias"
            loading="lazy"
            decoding="async"
            width="400"
            height="400"
          />
        </div>
        <div class="text">
          <h2>Mestre de Cerimônias</h2>
          <p>
            Sou MESTRE DE CERIMÔNIAS do GOVERNO DO ESTADO DO RIO DE JANEIRO desde 2009, em
            cerimônias com as presenças de autoridades nacionais (dos Poderes Executivo,
            Legislativo e Judiciário) e internacionais como o PAPA FRANCISCO,
            Primeiros-Ministros e Presidentes de vários países.
          </p>
        </div>
      </div>
    </section>

    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <video src="/assets/videos/BRAZIL_ENERGY_MEETING.mp4" controls preload="none" playsinline></video>
        </div>
        <div class="text">
          <h2>BRAZIL ENERGY MEETING</h2>
          <p>14ª edição, Jockey Clube do Brasil, RJ.</p>
        </div>
      </div>
    </section>

    <!-- MAX TITANIUM: vídeo manifesto -->
    <section class="section" data-aos="fade-left">
      <div class="container">
        <div class="text">
          <h2>MAX TITANIUM</h2>
          <p>
            Video manifesto para os SUPLEMENTOS ALIMENTARES MAX TITANIUM.
          </p>
        </div>
        <div class="media">
          <video
            src="/assets/videos/MAX-VIDEO-MANIFESTO-HORIZONTAL.mp4"
            controls
            preload="none"
            playsinline
          ></video>
        </div>
      </div>
    </section>

    <!-- VERÃO SEGURO: campanha Governo de Roraima -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <video
            src="/assets/videos/VT%20VERAO%20SEGURO%201_v5.mov"
            controls
            preload="none"
            playsinline
          ></video>
        </div>
        <div class="text">
          <h2>VERÃO SEGURO</h2>
          <p>
            Campanha de prevenção a queimadas do Governo de Roraima.
          </p>
        </div>
      </div>
    </section>

    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="text">
          <h2>NEOTERRAZO HOME CLUB</h2>
          <p>
            Empreendimento imobiliário.
          </p>
        </div>
        <div class="media">
          <video src="/assets/videos/neoterrazo.mp4" controls preload="none" playsinline></video>
        </div>
      </div>
    </section>


    <!-- Seção 3: Evento PRÉ-G20 -->
    <section class="section" data-aos="fade-left">
      <div class="container">
        <div class="text">
          <h2>Evento PRÉ-G20</h2>
          <p>
            Evento apresentado no RJ, com autoridades de diversos países (locução em
            inglês), no auditório do BNDES, em 2024.
          </p>
        </div>
        <div class="media">
          <video src="/assets/videos/BNDES_english.mp4" controls preload="none" playsinline></video>
        </div>
      </div>
    </section>

    <!-- Seção 4: Locução em Rádios -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <audio src="/assets/audios/SerraVerde01.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/SerraVerde02.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/rad-1.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/rad-2.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/rad-3.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/rad-4.mp3" controls preload="none"></audio>
        </div>
        <div class="text">
          <h2>Locução em Rádios</h2>
          <p>
            Atuei como locutor/anunciador/noticiarista em rádios de 1995 a 2010, incluindo
            TUPI FM, JB FM e PARADISO FM, no estilo adulto contemporâneo. Também gravo
            vinhetas e promos para outras estações até hoje.
          </p>
        </div>
      </div>
    </section>

    <!-- Seção 5: Locução FOX SPORTS -->
    <section class="section" data-aos="fade-left">
      <div class="container">
        <div class="text">
          <h2>Locução FOX SPORTS</h2>
          <p>
            Locutor de assinaturas, promos e trailers de filmes para os canais FOX SPORTS
            no Brasil e América Latina de 2012 a 2021.
          </p>
        </div>
        <div class="media">
          <video src="/assets/videos/Fox_Filmes.mp4" controls preload="none" playsinline></video>
          <video src="/assets/videos/Sevilla_X_Celta_Fox_Sports.mp4" controls preload="none" playsinline></video>
          <video src="/assets/videos/anunicio_1.mp4" controls preload="none" playsinline></video>
        </div>
      </div>
    </section>

    <!-- Seção 6: Locução TV Globo -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <video src="/assets/videos/Marighella.mp4" controls preload="none" playsinline></video>
        </div>
        <div class="text">
          <h2>Locução TV Globo</h2>
          <p>
            Tive uma experiência como "Voz Global", tendo como destaque as chamadas para a
            minissérie MARIGHELLA (2023).
          </p>
        </div>
      </div>
    </section>

    <!-- Seção 7: Video institucional para o agronegócio. -->
    <section class="section" data-aos="fade-left">
      <div class="container">
        <div class="text">
          <h2>Video institucional para o agronegócio.</h2>
        </div>
        <div class="media">
          <video src="/assets/videos/Labitah.mp4" controls preload="none" playsinline></video>
        </div>
      </div>
    </section>

    <!-- Seção 8: Comercial de TV -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <video src="/assets/videos/Cronus.mp4" controls preload="none" playsinline></video>
        </div>
        <div class="text">
          <h2>Comercial de TV (Empreendimento Imobiliário).</h2>
        </div>
      </div>
    </section>

    <!-- Seção 9: Mais áudios (estilos variados) -->
    <section class="section section-mais-audios" data-aos="fade-left">
      <div class="container mais-audios">
        <div class="text mais-audios-intro">
          <h2>Mais áudios (estilos variados)</h2>
          <p>
            Uma coleção de locuções com estilos variados, demonstrando versatilidade em
            diferentes formatos de áudio.
          </p>
        </div>
        <div class="media mais-audios-list">
          <audio src="/assets/audios/audio-trab1.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/audio-trab2.mp3" controls preload="none"></audio>
          <!-- <audio src="/assets/audios/audio-trab3.mp3" controls preload="none"></audio> -->
          <audio src="/assets/audios/audio-trab4.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/01.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/02.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/03.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/04.mp3" controls preload="none"></audio>
          <audio src="/assets/audios/05.mp3" controls preload="none"></audio>
        </div>
      </div>
    </section>

    <!-- Seção 10: Segurança Presente -->
    <section class="section" data-aos="fade-right">
      <div class="container">
        <div class="media">
          <video
            src="/assets/videos/16_anos_da_OPERACAO_LEI_SECA_no_Rio_de_Janeiro.mp4"
            controls
            preload="none"
            playsinline
          ></video>
        </div>
        <div class="text text-padded">
          <h2>LEI SECA 16 ANOS</h2>
          <p>Institucional para o Governo do Estado do Rio de Janeiro.</p>
        </div>
      </div>
    </section>

    <!-- Seção 11: Segurança Presente -->
    <section class="section" data-aos="fade-left">
      <div class="container container-centered container-dj">
        <div class="text text-nowrap-left dj-section-title">
          <h2 class="title-compact">
            VINHETAS PARA DJ'S
          </h2>
        </div>
        <div class="media dj-media-video">
          <video src="/assets/videos/videoDJ1.mp4" controls preload="none" playsinline></video>
        </div>
        <div class="media media-column dj-media-audios">
          <audio
            src="/assets/audios/audioDJ3.mp3"
            controls
            preload="none"
            class="audio-fixed-size"
          ></audio>
          <audio
            src="/assets/audios/audioDJ1.mp3"
            controls
            preload="none"
            class="audio-fixed-size"
          ></audio>
          <audio
            src="/assets/audios/audioDJ2.mp3"
            controls
            preload="none"
            class="audio-fixed-size"
          ></audio>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";

export default {
  name: "BioDoArtista",
  mounted() {
    AOS.init({
      duration: 1000,
      once: true,
    });
  },
};
</script>

<style scoped>
:root {
  --title-size: clamp(1.7rem, 2vw + 1rem, 2.3rem);
  --body-size: clamp(1rem, 0.4vw + 0.95rem, 1.2rem);
  --container-max-width: 1200px;
  --media-max-width: 400px;
}

/* Seção Principal */
.section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to bottom, #19014e, #2c00a7);
  padding: clamp(36px, 6vw, 56px) 20px;
  text-align: center;
}

.section:nth-child(odd) {
  background: linear-gradient(to bottom, #19014e, #240078);
}

.section:nth-child(even) {
  background: linear-gradient(to bottom, #240078, #2c00a7);
}

.container {
  display: flex;
  flex-wrap: wrap;
  max-width: var(--container-max-width);
  margin: auto;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 2vw, 28px);
}

.media {
  flex: 1;
  max-width: var(--media-max-width);
  margin: 20px;
}

/* Imagem e vídeo: dimensão intrínseca + object-fit. */
.media img,
.media video {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 10px 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  object-fit: contain;
  display: block;
}

/**
 * Controles nativos de <audio> precisam de altura mínima estável.
 * object-fit + height:auto (herdados como no bloco anterior) fazem a caixa
 * colapsar em alguns navegadores e os reprodutores somem visualmente.
 */
.media audio {
  width: 100%;
  max-width: 100%;
  min-height: 54px;
  margin: 10px 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  display: block;
}

.text {
  flex: 2;
  margin: 20px;
  max-width: 68ch;
}

.text h2 {
  font-size: var(--title-size);
  color: #e9e9e9;
  margin-bottom: 18px;
  line-height: 1.2;
  letter-spacing: 0.01em;
  text-wrap: balance;
}

.text p {
  font-size: var(--body-size);
  line-height: 1.75;
  color: #c9c9c9;
  font-weight: 400;
  max-width: 60ch;
  margin: 0 auto;
}

.text-padded {
  padding: 24px;
}

.container-centered {
  justify-content: center;
  gap: 40px;
}

/**
 * "Mais áudios": o flex padrão (text flex:2 + media flex:1) criava coluna de players
 * estreita e muito espaço vazio; o bloco de texto não alinhava bem com a pilha alta.
 * Grelha com alinhamento vertical +, em ecrã largo, players em 2 colunas.
 */
.section-mais-audios .container.mais-audios {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 400px);
  align-items: center;
  gap: clamp(24px, 4vw, 48px);
  width: 100%;
  max-width: min(100%, 1080px);
}

.section-mais-audios .mais-audios-intro {
  flex: unset;
  margin: 12px 16px;
  max-width: 48ch;
  justify-self: center;
}

.section-mais-audios .mais-audios-list {
  flex: unset;
  max-width: none;
  width: 100%;
  margin: 12px 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-content: start;
}

@media (max-width: 959px) {
  .section-mais-audios .container.mais-audios {
    grid-template-columns: 1fr;
    gap: clamp(20px, 4vw, 32px);
  }
}

@media (min-width: 960px) {
  .section-mais-audios .container.mais-audios {
    grid-template-columns: minmax(0, 44ch) minmax(480px, 1fr);
  }

  .section-mais-audios .mais-audios-list {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 12px;
    max-width: 640px;
  }
}

/**
 * Três colunas (título + vídeo + áudios): flex:1 em .media fazia as colunas
 * encolherem abaixo da largura útil — vídeo em faixa vertical e áudios estreitos.
 * Larguras mínimas e flex-basis estáveis preservam o layout dos controlos nativos.
 */
.container-dj {
  flex-wrap: wrap;
  align-items: center;
}

.container-dj .dj-section-title {
  flex: 0 0 auto;
  margin-inline: 16px;
}

.container-dj .dj-media-video {
  flex: 1 1 320px;
  min-width: min(100%, 280px);
  max-width: 420px;
}

.container-dj .dj-media-audios {
  flex: 0 0 auto;
  width: min(100%, 280px);
  min-width: min(100%, 260px);
  max-width: 280px;
}

.text-nowrap-left {
  text-align: left;
  white-space: nowrap;
}

.title-compact {
  font-size: var(--title-size);
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}

.media-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.audio-fixed-size {
  width: 250px;
  height: 50px;
}

/**
 * .media audio usa width:100% com maior especificidade que só .audio-fixed-size;
 * sem isto, o player herda a largura da coluna (às vezes poucos px).
 */
.media audio.audio-fixed-size {
  width: 250px;
  min-width: 250px;
  max-width: 100%;
  min-height: 50px;
  box-sizing: border-box;
}

.container-dj .dj-media-audios audio.audio-fixed-size {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 8px;
  }

  .container-dj .dj-media-video,
  .container-dj .dj-media-audios {
    width: 100%;
    max-width: min(100%, 420px);
    min-width: 0;
  }

  .text,
  .media {
    margin: 10px 0;
  }

  .text {
    max-width: 100%;
  }

  .text p {
    max-width: 100%;
  }

  .media audio {
    display: block;
    margin-top: 15px;
    width: 90%;
    /* Ajusta para ocupar 90% do espaço disponível */
    min-width: 250px;
    /* Define um tamanho mínimo para o player */
    max-width: 100%;
    /* Garante que não ultrapasse o container */
  }
}

@media (max-width: 480px) {
  .media audio {
    width: 100%;
    /* Para telas muito pequenas, ocupa toda a largura disponível */
  }
}
</style>
